import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { IdentityService } from '../services/identity/identity.service';

@Directive({
  selector: '[appHasRole], [hasRole]',
  standalone: true
})
export class HasRoleDirective {
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private identityService = inject(IdentityService);

  private isCreated = false;
  private currentRoles: string | string[] | null | undefined = null;

  /*
   * Input property setter for *hasRole directive usage.
   */
  @Input('hasRole') set hasRole(roles: string | string[] | null | undefined) {
    this.currentRoles = roles;
    this.updateView();
  }

  /*
   * Alias input property setter for *appHasRole directive usage.
   */
  @Input('appHasRole') set appHasRole(roles: string | string[] | null | undefined) {
    this.currentRoles = roles;
    this.updateView();
  }

  /*
   * Evaluates the current required roles against the user's active claims
   * and creates or destroys the embedded view container accordingly.
   */
  private updateView(): void {
    if (!this.currentRoles) {
      this.clearView();
      return;
    }

    const hasAccess = this.identityService.hasRole(this.currentRoles);

    // Create view if user has access and view isn't attached yet
    if (hasAccess && !this.isCreated) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isCreated = true;
    } else if (!hasAccess && this.isCreated) {
      this.clearView();
    }
  }

  /*
   * Clears the embedded view and resets creation tracking flag.
   */
  private clearView(): void {
    this.viewContainer.clear();
    this.isCreated = false;
  }
}
